import type { ComponentPropsWithRef } from "react";

/** Stable semantic regions owned by the shared Workspace Shell grammar. */
export function WorkspaceShellHeader(props: ComponentPropsWithRef<"header">) {
  return <header {...props} data-workspace-header="" />;
}

export function WorkspaceShellRegion({
  name,
  ...props
}: ComponentPropsWithRef<"div"> & { readonly name: string }) {
  return <div {...props} data-workspace-region={name} />;
}

export function WorkspaceShellMain(props: ComponentPropsWithRef<"main">) {
  return <main {...props} data-workspace-main="" />;
}

export function WorkspaceShellComposer(props: ComponentPropsWithRef<"div">) {
  return <div {...props} data-workspace-composer="" />;
}

export function WorkspaceShellSurfaceControls(props: ComponentPropsWithRef<"div">) {
  return <div {...props} data-workspace-surface-controls="" />;
}

export function WorkspaceShellStatus({
  kind,
  ...props
}: ComponentPropsWithRef<"section"> & {
  readonly kind: "empty" | "error" | "loading";
}) {
  const role = props.role ?? (kind === "error" ? "alert" : "status");
  return <section {...props} data-workspace-status={kind} role={role} />;
}
